import { create } from 'zustand'

type AVSheetState = {
  isOpen: boolean
  open: () => void
  close: () => void
}

export const useAVSheetStore = create<AVSheetState>((set) => ({
  isOpen: false,
  open: () => set({ isOpen: true }),
  close: () => set({ isOpen: false }),
}))
